import types from '../types/addresses'
import profileTypes from '../types/profile'
import {Map, List} from 'immutable'

const initialAddresses = List()

function addresses(state = initialAddresses, action) {
  switch (action.type) {
    case profileTypes.FETCH_SUCCESS:
      return List(action.payload.addresses.addresses)
    case types.SAVE_EDIT_SUCCESS:
      return state.set(state.findIndex(item => item.ID === action.payload.id), action.payload.address)
    case types.SAVE_ADD_SUCCESS:
      return state.push(action.payload.address)
    case types.SAVE_REMOVE_SUCCESS:
      return state.delete(state.findIndex(item => item.ID === action.payload.id))
    default:
      return state
  }
}

const initialSelected = Map({
  id: 0,
  original: '',
  address: '',
  number: '',
  floor: '',
  apartment: '',
  postalCode: '',
  emptyFieldErrors: Map({
    original: '',
    address: '',
    number: '',
    postalCode: ''
  })
})

function selected(state = initialSelected, action) {
  switch (action.type) {
    case types.SET_ORIGINAL:
      return state.merge({
        original: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('original', '')
      })
    case types.SET_ADDRESS:
      return state.merge({
        address: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('address', '')
      })
    case types.SET_FLOOR:
      return state.set('floor', action.payload.value)
    case types.SET_APARTMENT:
      return state.set('apartment', action.payload.value)
    case types.SET_POSTAL_CODE:
      return state.merge({
        postalCode: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('postalCode', '')
      })
    case types.SET_STREET_NUMBER:
      return state.merge({
        number: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('number', '')
      })
    case types.SET_EMPTY_FIELD_ERROR:
      return state.set('emptyFieldErrors', Map(action.payload.emptyFieldErrors))
    case types.ADD:
      return initialSelected
    case types.EDIT:
      return state.merge({
        id: action.payload.id,
        original: action.payload.original,
        address: action.payload.address,
        number: action.payload.number,
        floor: action.payload.floor,
        apartment: action.payload.apartment,
        postalCode: action.payload.postalCode,
        emptyFieldErrors: Map({
          original: '',
          address: '',
          number: '',
          postalCode: ''
        })
      })
    case types.REMOVE:
      return state.merge({
        id: action.payload.id,
        address: action.payload.address,
      })
    default:
      return state
  }
}

const initialRoot = Map({
  isLoading: false,
  error: '',
  editDialogShow: false,
  addDialogShow: false,
  removeDialogShow: false,
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_ADDRESS:
      return state.set('error', '')
    case types.EDIT:
      return state.merge({
        editDialogShow: true,
        error: '',
      })
    case types.SAVE_EDIT:
      return state.set('isLoading', true)
    case types.SAVE_EDIT_SUCCESS:
      return state.merge({
        'isLoading': false,
        'error': '',
        'editDialogShow': false,
      })
    case types.SAVE_EDIT_FAIL:
      return state.merge({
        'isLoading': false,
        'error': action.payload.error,
      })
    case types.SET_EDIT_DIALOG_OPEN:
      return state.set('editDialogShow', action.payload.show)
    case types.ADD:
      return state.merge({
        addDialogShow: true,
        error: '',
      })
    case types.SAVE_ADD:
      return state.set('isLoading', true)
    case types.SAVE_ADD_SUCCESS:
      return state.merge({
        'isLoading': false,
        'error': '',
        'addDialogShow': false,
      })
    case types.SAVE_ADD_FAIL:
      return state.merge({
        'isLoading': false,
        'error': action.payload.error,
      })
    case types.SET_ADD_DIALOG_OPEN:
      return state.set('addDialogShow', action.payload.show)
    case types.REMOVE:
      return state.set('removeDialogShow', true)
    case types.SAVE_REMOVE:
      return state.set('isLoading', true)
    case types.SAVE_REMOVE_SUCCESS:
      return state.merge({
        'isLoading': false,
        'error': '',
        'removeDialogShow': false,
      })
    case types.SAVE_REMOVE_FAIL:
      return state.merge({
        'isLoading': false,
        'error': action.payload.error,
      })
    case types.SET_REMOVE_DIALOG_OPEN:
      return state.set('removeDialogShow', action.payload.show)
    default:
      return state
  }
}

export default function(state, action) {
  const m = Map({
    addresses: addresses(state ? state.get('addresses') : undefined, action),
    selected: selected(state ? state.get('selected') : undefined, action),
  })
  return root(state, action).merge(m)
}



// WEBPACK FOOTER //
// ./src/sections/profile/reducers/addresses.js